import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    CircularProgress,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Typography,
    Divider,
    ListItemIcon,
    Chip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import { linksAPI } from '../services/api';
import LinkDetailsDialog from './LinkDetailsDialog';

interface PersonDetailsDialogProps {
    open: boolean;
    onClose: () => void;
    personId: number | null;
    personName: string;
}

const PersonDetailsDialog: React.FC<PersonDetailsDialogProps> = ({ open, onClose, personId, personName }) => {
    const [loading, setLoading] = useState(false);
    const [links, setLinks] = useState<any[]>([]);

    // Link Detail State
    const [selectedLinkId, setSelectedLinkId] = useState<number | null>(null);
    const [detailOpen, setDetailOpen] = useState(false);
    const [selectedVideoTitle, setSelectedVideoTitle] = useState('');

    useEffect(() => {
        if (open && personId) {
            fetchLinks();
        } else {
            setLinks([]);
        }
    }, [open, personId]);

    const fetchLinks = async () => {
        if (!personId) return;
        setLoading(true);
        try {
            const response = await linksAPI.getPersonLinks(personId);
            setLinks(response.data);
        } catch (error) {
            console.error('Linkler alınamadı:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleLinkClick = (link: any) => {
        setSelectedLinkId(link.id);
        setSelectedVideoTitle(link.video_title);
        setDetailOpen(true);
    };

    const handleDetailClose = () => {
        setDetailOpen(false);
        setSelectedLinkId(null);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
                    {personName} - Videoları
                    <IconButton onClick={onClose}><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    {loading ? (
                        <Box display="flex" justifyContent="center" p={3}><CircularProgress /></Box>
                    ) : links.length > 0 ? (
                        <List>
                            {links.map((link) => (
                                <ListItem key={link.id} disablePadding>
                                    <ListItemButton onClick={() => handleLinkClick(link)}>
                                        <ListItemIcon>
                                            <VideoLibraryIcon color="primary" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={link.video_title}
                                            secondary={`Oluşturulma: ${new Date(link.created_at).toLocaleDateString()}`}
                                        />
                                        <Box>
                                            {/* Basit bir ok işareti veya info ikonu olabilir */}
                                            <PlayCircleOutlineIcon color="action" />
                                        </Box>
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Box display="flex" flexDirection="column" alignItems="center" py={4}>
                            <Typography color="text.secondary">Bu kişiyle henüz hiç video paylaşılmamış.</Typography>
                        </Box>
                    )}
                </DialogContent>
            </Dialog>

            {/* Nested Dialog for Link Details */}
            <LinkDetailsDialog
                open={detailOpen}
                onClose={handleDetailClose}
                linkId={selectedLinkId}
                title={`${personName} - ${selectedVideoTitle}`}
            />
        </>
    );
};

export default PersonDetailsDialog;
